import { TableFilterApiBody } from '../types'
import {
  CreatePermissionSetPayloadType,
  UpdatePermissionApiType,
  UpdatePermissionSetPayloadType,
} from '../types/userAccessControl.types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

export const getPermissionsList = (filter: TableFilterApiBody) => {
  return axiosInstance.post(
    `${API_END_POINT.CORE}permission-set/listPermissions/advance`,
    filter,
    {
      headers: {
        'X-TenantId': '',
      },
    }
  )
}

export const savePermissionSetForCreate = (
  payload: CreatePermissionSetPayloadType
) => {
  return axiosInstance.post(`${API_END_POINT.CORE}permission-set`, payload, {
    headers: {
      'X-TenantId': '',
    },
  })
}

export const getPermissionSets = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}permission-set`, {
    headers: {
      'X-TenantId': '',
    },
  })
}

export const getPermissionList = async (payload: {
  selectedPermissionSetId: string
}) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}permission-set/fetchById/${payload.selectedPermissionSetId}`,
    {
      headers: {
        'X-TenantId': '',
      },
    }
  )
}

export const updatePermissionSet = async (
  payload: UpdatePermissionApiType[],
  permissionSetId: string
) => {
  return await axiosInstance.patch(
    `${API_END_POINT.CORE}permission-set/${permissionSetId}`,
    payload
  )
}
export const savePermissionSetForEdit = async (
  payload: UpdatePermissionSetPayloadType,
  permissionSetId: number
) => {
  return await axiosInstance.put(
    `${API_END_POINT.CORE}permission-set/${permissionSetId}`,
    payload,
    {
      headers: {
        'X-TenantId': '',
      },
    }
  )
}
